import { ref } from 'vue';
import { useStore, setMeta } from '@/store';
import { useSanity } from '@/sanity';

export default function sanityRequest<T>() {
  const sanity = useSanity();
  const store = useStore();

  const loading = ref(false);
  const data = ref<T>();

  const setData = (newData: T) => {
    data.value = newData;
    loading.value = false;
  };

  return { sanity, store, loading, data, setData, setMeta };
}
